"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAssetRejected = exports.isAssetApproved = exports.isAssetPending = void 0;
const AssetStatus_1 = require("./AssetStatus");
function isAssetPending(asset) {
    return asset.status === AssetStatus_1.AssetStatus.PENDING;
}
exports.isAssetPending = isAssetPending;
function isAssetApproved(asset) {
    return asset.status === AssetStatus_1.AssetStatus.APPROVED;
}
exports.isAssetApproved = isAssetApproved;
function isAssetRejected(asset) {
    return asset.status === AssetStatus_1.AssetStatus.REJECTED;
}
exports.isAssetRejected = isAssetRejected;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXNzZXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHlwZXMvQXNzZXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsK0NBQTRDO0FBb0I1QyxTQUFnQixjQUFjLENBQUMsS0FBNEI7SUFDekQsT0FBTyxLQUFLLENBQUMsTUFBTSxLQUFLLHlCQUFXLENBQUMsT0FBTyxDQUFDO0FBQzlDLENBQUM7QUFGRCx3Q0FFQztBQUVELFNBQWdCLGVBQWUsQ0FBQyxLQUE0QjtJQUMxRCxPQUFPLEtBQUssQ0FBQyxNQUFNLEtBQUsseUJBQVcsQ0FBQyxRQUFRLENBQUM7QUFDL0MsQ0FBQztBQUZELDBDQUVDO0FBRUQsU0FBZ0IsZUFBZSxDQUFDLEtBQTRCO0lBQzFELE9BQU8sS0FBSyxDQUFDLE1BQU0sS0FBSyx5QkFBVyxDQUFDLFFBQVEsQ0FBQztBQUMvQyxDQUFDO0FBRkQsMENBRUMifQ==